import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Edit } from '@amzn/dvui/dist/Icons/Edit'
import { Help } from '@amzn/dvui/dist/Icons/Help'
import { Share } from '@amzn/dvui/dist/Icons/Share'
import { WatchParty } from '@amzn/dvui/dist/Icons/WatchParty'
import { Spacer, spacerSpacing } from '@amzn/dvui/dist/Spacer'
import { Text } from '@amzn/dvui/dist/Text'
import { ShareModal } from '@shared/components/shareModal/shareModal'
import { FeedbackForm } from '../feedbackForm/feedbackForm'
import * as st from './bottomBar.module.scss'
import { WatchPartyLink } from '../watchPartyLink/watchPartyLink'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as cn from 'classnames'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'

export interface IBottomBarProps extends AtfTreatmentProps {
  isMobile: boolean
  isPurchaseRestricted: boolean
  isRetail: boolean
  bottomBar: WpsRuntime.atv.wps.BottomBarModelProps
  watchPartyAction?: WpsRuntime.atv.wps.WatchPartyActionProps
}

const TermsAndConditions = ({ termsText }: {termsText: WpsRuntime.atv.wps.DVString}) => (
  <div className={`${utilityClasses.fullWidth} ${st.termsAndConditions}`}>
    <Text string={termsText}/>
  </div>
)

export const BottomIconWithLink: React.FunctionComponent<{icon: React.ReactNode}> = ({ icon, children }) => (
  <div className={st.linkWithIcon}>
    <div className={st.bottomIcon}>
      {icon}
    </div>
    {children}
  </div>
)

type WatchPartyLinkWrapperProps = {
  watchPartyAction?: WpsRuntime.atv.wps.WatchPartyActionProps
  withFTUETooltip?: boolean
} & AtfTreatmentProps

const WatchPartyLinkWrapper = ({ watchPartyAction, atfTreatment, withFTUETooltip }: WatchPartyLinkWrapperProps) => {
  return watchPartyAction && isTreatment(atfTreatment, 'C') ?
  <BottomIconWithLink icon={<WatchParty />}>
      <WatchPartyLink watchPartyAction={watchPartyAction} withFTUETooltip={withFTUETooltip} />
  </BottomIconWithLink> : null
}

export const BottomBarComp = ({ isPurchaseRestricted, isRetail, bottomBar, atfTreatment, watchPartyAction }: IBottomBarProps) => {

  return (
    !isPurchaseRestricted ? (
      <div className={cn('dv-dp-node-bottom', st.bottomBar, {[st.bottomBarRedesign]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
        {!global.__NATIVEAPP__ && <TermsAndConditions termsText={bottomBar.termsText}/>}
        <Spacer className={st.iconsAndFeedback} space={spacerSpacing.m}>
          <WatchPartyLinkWrapper
            watchPartyAction={watchPartyAction}
            atfTreatment={atfTreatment}
            withFTUETooltip={true}
          />
          <BottomIconWithLink icon={<Share />}><ShareModal shareWidgetModel={bottomBar.shareWidgetModel} refTag="atv_dp_share_open"/></BottomIconWithLink>
          {isRetail && <BottomIconWithLink icon={<Edit />}>{<FeedbackForm />}</BottomIconWithLink>}
          <BottomIconWithLink icon={<Help />}>
            <span data-automation-id="get-help-link" data-testid="get-help-link">
              <Text string={bottomBar.helpText}/>
            </span>
          </BottomIconWithLink>
        </Spacer>
      </div>
    ) : null
  )
}

export const BottomBar = BottomBarComp
